import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'styleStringToObj', pure: true})
export class StyleStringToObjPipe implements PipeTransform {
  transform(css: string): { [prop: string]: string } | null {
    if (!css) return null;
    const result: { [prop: string]: string } = {};
    css.split(';').forEach(decl => {
      const idx = decl.indexOf(':');
      if (idx < 0) return;
      const prop = decl.slice(0, idx).trim();
      const val = decl.slice(idx + 1).trim();
      if (prop && val) result[prop] = val;
    });
    return Object.keys(result).length ? result : null;
  }
}
